import { message } from 'antd'
import LinkedMember from '../../../../components/Main/Group/LinkedMember/LinkedMember'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalData from '../../../../elements/Hooks/useModalData'
import { pick } from 'lodash'
import React from 'react'
import { GroupsApi } from '../../../../api/Groups'


function LinkedMemberCont(props) {
  const { group } = props
  const { list, fetching, fetch } = useFetchList(() => GroupsApi.getLinkedMemberByGroup(group._key))

  const {
    visible,
    modalType,
    object: link,
    submitting,
    setSubmitting,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    checkForm,
  } = useModalData(undefined, undefined, GroupsApi.links.remove, fetch)

  async function submit() {
    const newObject = await checkForm()
    setSubmitting(true)
    try {
      await GroupsApi.links.create({ ...newObject, group: pick(group, '_id') })
      onCancel()
      fetch()
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmitting(false)
  }

  return (
    <LinkedMember
      {...{
        list,
        fetching,
        fetch,
        visible,
        submitting,
        group,
        link,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
      }}
    />
  )
}

export default (LinkedMemberCont)
